import type { AgentAssignedListItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";

export const getSelectedAdvisor = (
	advisors: AgentAssignedListItemResponseDTO[],
	selectedId?: string,
) =>
	advisors.find((advisor) => advisor.uid === selectedId) ??
	advisors.find((advisor) => advisor.isMain) ??
	advisors[0];
